import { ENV } from "./env";

export const APP_CONFIG = {
  appName: ENV.APP_NAME,
  appLogo: ENV.APP_LOGO,
  apiUrl: ENV.API_URL,
};
